export enum SitePath
{    Home = '/',
     SELL_NOW_PAGE = '/sell-used-appliances',
     ORDER_SUMMARY_PAGE ="/order-summary",
     CART_PAGE = "/cart/listing",
}

